import { SearchRounded } from '@mui/icons-material';
import {
  Box,
  Divider,
  InputAdornment,
  ListItem,
  ListItemText,
  Menu,
  TextField,
} from '@mui/material';
import { SyntheticEvent, useDeferredValue, useState } from 'react';
import { AddToNewCollectionButton } from '../../AddToNewCollectionButton';
import { CollectionList } from '../CollectionList';
import { EmptyCollectionListView } from '../EmptyCollectionListView';
import { useFetchCollectionsForFeedbackRecord } from '../hooks';

interface AddFeedbackToCollectionMenuProps {
  anchorEl: null | HTMLButtonElement;
  open: boolean;
  onClose: (event: SyntheticEvent) => void;
  feedbackID: string;
}

export const AddFeedbackToCollectionMenu = ({
  anchorEl,
  open,
  onClose,
  feedbackID,
}: AddFeedbackToCollectionMenuProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const deferredSearchQuery = useDeferredValue(searchQuery);

  const { collections, isLoading, fetchMore, hasMore } =
    useFetchCollectionsForFeedbackRecord({
      searchTerm: deferredSearchQuery,
    });

  const onQueryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const isCollectionListEmpty = collections.length === 0 && !isLoading;

  return (
    <Menu
      id="add-to-collection-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      MenuListProps={{
        'aria-labelledby': 'save-to-collection-button',
        sx: { py: 0 },
      }}
      PaperProps={{
        elevation: 8,
        sx: {
          width: 370,
          maxWidth: '100%',
          overflow: 'hidden',
        },
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <ListItem>
        <ListItemText primary="Choose Collection(s) to add to" />
      </ListItem>
      <Divider />
      {isCollectionListEmpty ? (
        <EmptyCollectionListView />
      ) : (
        <Box>
          <ListItem>
            <TextField
              fullWidth
              color="primary"
              onKeyDown={(event) => event.stopPropagation()}
              value={searchQuery}
              placeholder="Search Collections"
              onChange={onQueryChange}
              variant="standard"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchRounded color="disabled" />
                  </InputAdornment>
                ),
              }}
            />
          </ListItem>

          <CollectionList
            collections={collections}
            hasNextPage={hasMore}
            isLoadingFirstPage={isLoading && collections.length === 0}
            fetchMore={fetchMore}
            feedbackID={feedbackID}
          />
        </Box>
      )}
      <AddToNewCollectionButton feedbackID={feedbackID} />
    </Menu>
  );
};
